import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import toast from "react-hot-toast";

import API from "../../services/api";

function ViewPurchase() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [purchase,
    setPurchase] =
    useState(null);

  const [items,
    setItems] =
    useState([]);

  const [payments,
    setPayments] =
    useState([]);

  const [loading,
    setLoading] =
    useState(true);

  useEffect(() => {
    loadPurchase();
  }, []);

  const loadPurchase =
    async () => {

      try {

        setLoading(true);

        const res =
          await API.get(
            `/purchases/${id}`
          );

        setPurchase(
          res.data.purchase
        );

        setItems(
          res.data.items || []
        );

        setPayments(
          res.data.payments || []
        );

      } catch (err) {

        console.log(err);

        toast.error(
          err.response?.data?.message ||
          "Failed to load purchase."
        );

      } finally {

        setLoading(false);

      }

    };

  const printInvoice = () => {

    document.title =
      `Purchase-${purchase.invoice_no}`;

    window.print();

  };

  if (loading) {

    return (

      <div
        className="
            flex
            justify-center
            items-center
            h-[400px]
            text-xl
            "
      >
        Loading...
      </div>

    );

  }

  if (!purchase) {

    return (

      <div
        className="
            text-center
            py-20
            "
      >
        Purchase not found.
      </div>

    );

  }

  return (
    
  <div>

    <div
      className="
    flex
    justify-between
    items-center
    mb-6
    no-print
  "
    >

      <h1
        className="
      text-3xl
      font-bold
    "
      >
        Purchase Invoice
      </h1>

      <div
        className="
flex
gap-3
flex-wrap
"
      >

        {
          Number(
            purchase.due_amount
          ) > 0 && (

            <button

              onClick={() =>

                navigate(

                  "/admin/purchases/receive-payment",

                  {

                    state: {

                      purchase

                    }

                  }

                )

              }

              className="
            px-5
            py-3
            bg-green-600
            rounded-xl
            font-semibold
            "
            >

              Pay Payment

            </button>

          )
        }

        <button
          onClick={printInvoice}
          className="
        px-5
        py-3
        bg-blue-500
        rounded-xl
      "
        >
          Print
        </button>

        <button
          onClick={() =>
            navigate(
              "/admin/purchases"
            )
          }
          className="
        px-5
        py-3
        bg-yellow-500
        text-black
        rounded-xl
      "
        >
          Back
        </button>

      </div>

    </div>

    <div
      id="invoice"
      className="
  invoice-print
  bg-[#111]
  rounded-2xl
  p-6
"
    >

      {/* HEADER */}

      {/* ==========================================
    PURCHASE HEADER
========================================== */}

      <div
        className="
    grid
    grid-cols-2
    gap-6
    mb-8
    "
      >

        {/* Supplier */}

        <div
          className="
        bg-black/30
        rounded-2xl
        p-6
        border
        border-yellow-500/20
        "
        >

          <h2
            className="
            text-xl
            font-bold
            mb-5
            "
          >
            Supplier Details
          </h2>

          <div className="space-y-3">

            <p>

              <span className="font-semibold">
                Name :
              </span>

              {" "}

              {purchase.supplier_name}

            </p>

            <p>

              <span className="font-semibold">
                Phone :
              </span>

              {" "}

              {purchase.phone || "-"}

            </p>

            <p>

              <span className="font-semibold">
                Email :
              </span>

              {" "}

              {purchase.email || "-"}

            </p>

            <p>

              <span className="font-semibold">
                Address :
              </span>

              {" "}

              {purchase.address || "-"}

            </p>

          </div>

        </div>

        {/* Purchase */}

        <div
          className="
        bg-black/30
        rounded-2xl
        p-6
        border
        border-yellow-500/20
        "
        >

          <h2
            className="
            text-xl
            font-bold
            mb-5
            "
          >
            Purchase Information
          </h2>

          <div className="space-y-3">

            <p>

              <span className="font-semibold">
                Invoice No :
              </span>

              {" "}

              {purchase.invoice_no}

            </p>

            <p>

              <span className="font-semibold">
                Purchase Date :
              </span>

              {" "}

              {purchase.purchase_date}

            </p>

            <p>

              <span className="font-semibold">
                Purchase ID :
              </span>

              {" "}

              #{purchase.id}

            </p>

            <p>

              <span className="font-semibold">
                Payment Status :
              </span>

              {" "}

              <span
                className={`
                    px-3
                    py-1
                    rounded-full
                    text-sm
                    font-semibold

                    ${purchase.payment_status === "Paid"

                    ? "bg-green-600"

                    : purchase.payment_status === "Partial"

                      ? "bg-yellow-500 text-black"

                      : "bg-red-600"

                  }
                    `}
              >

                {purchase.payment_status}

              </span>

            </p>

          </div>

        </div>

      </div>

      {/* ITEMS */}

      <div
        className="
      overflow-x-auto
    "
      >

        <table
          className="
        w-full
      "
        >

          <thead>

            <tr
              className="
            border-b
            border-yellow-500/20
          "
            >

              <th className="p-3 text-left">
                Product
              </th>

              <th className="p-3 text-center">
                Qty
              </th>

              <th className="p-3 text-center">
                Price
              </th>

              <th className="p-3 text-center">
                GST %
              </th>

              <th className="p-3 text-center">
                Amount
              </th>

            </tr>

          </thead>

          <tbody>

            {items.map(
              (
                item,
                index
              ) => (

                <tr
                  key={index}
                  className="
                border-b
                border-yellow-500/10
              "
                >

                  <td className="p-3">
                    {item.name}
                  </td>

                  <td className="p-3 text-center">
                    {item.qty}
                  </td>

                  <td className="p-3 text-center">
                    ₹
                    {
                      item.purchase_price
                    }
                  </td>

                  <td className="p-3 text-center">
                    {
                      item.gst_percent
                    }
                    %
                  </td>

                  <td className="p-3 text-center">
                    ₹
                    {
                      item.amount
                    }
                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

      </div>

      {/* TOTALS */}

      {/* ==========================================
    PURCHASE TOTALS
========================================== */}

      <div
        className="
    mt-10
    flex
    justify-end
    "
      >

        <div
          className="
        w-full
        lg:w-[420px]
        bg-black/30
        border
        border-yellow-500/20
        rounded-2xl
        p-6
        "
        >

          <h2
            className="
            text-xl
            font-bold
            mb-6
            "
          >
            Financial Summary
          </h2>

          {/* Subtotal */}

          <div
            className="
            flex
            justify-between
            mb-4
            "
          >

            <span className="text-gray-400">
              Subtotal
            </span>

            <span>
              ₹
              {Number(
                purchase.subtotal
              ).toFixed(2)}
            </span>

          </div>

          {/* GST */}

          <div
            className="
            flex
            justify-between
            mb-4
            "
          >

            <span className="text-gray-400">
              GST
            </span>

            <span>
              ₹
              {Number(
                purchase.gst_total
              ).toFixed(2)}
            </span>

          </div>

          {/* Discount */}

          <div
            className="
            flex
            justify-between
            mb-4
            "
          >

            <span className="text-gray-400">
              Discount
            </span>

            <span className="text-red-400">
              - ₹
              {Number(
                purchase.discount || 0
              ).toFixed(2)}
            </span>

          </div>

          <hr className="border-yellow-500/20 my-5" />

          {/* Grand Total */}

          <div
            className="
            flex
            justify-between
            text-xl
            font-bold
            "
          >

            <span>
              Grand Total
            </span>

            <span className="text-yellow-400">

              ₹

              {Number(
                purchase.grand_total
              ).toFixed(2)}

            </span>

          </div>

          <hr className="border-yellow-500/20 my-5" />

          {/* Paid */}

          <div
            className="
            flex
            justify-between
            mb-4
            "
          >

            <span className="text-gray-400">
              Paid Amount
            </span>

            <span className="text-green-400">

              ₹

              {Number(
                purchase.paid_amount
              ).toFixed(2)}

            </span>

          </div>

          {/* Due */}

          <div
            className="
            flex
            justify-between
            mb-5
            "
          >

            <span className="text-gray-400">
              Due Amount
            </span>

            <span
              className={`
                font-bold

                ${Number(
                purchase.due_amount
              ) === 0

                  ? "text-green-400"

                  : "text-red-400"

                }
                `}
            >

              ₹

              {Number(
                purchase.due_amount
              ).toFixed(2)}

            </span>

          </div>

        </div>

      </div>

      {/* ==========================================
    PAYMENT HISTORY
========================================== */}

      <div
        className="
    mt-10
    bg-black/30
    border
    border-yellow-500/20
    rounded-2xl
    p-6
    "
      >

        <div
          className="
        flex
        justify-between
        items-center
        lg:mb-6
        "
        >

          <h2
            className="
            text-2xl
            font-bold
            "
          >
            Payment History
          </h2>

          <span
            className="
            px-4
            py-2
            rounded-full
            bg-yellow-500/20
            text-yellow-400
            font-semibold
            "
          >
            {payments.length} Payments
          </span>

        </div>

        {

          payments.length === 0 ? (

            <div
              className="
                text-center
                py-10
                text-gray-400
                "
            >

              No payment history found.

            </div>

          ) : (

            <div
              className="
                overflow-x-auto
                "
            >

              <table
                className="
                    w-full
                    "
              >

                <thead>

                  <tr
                    className="
                            border-b
                            border-yellow-500/20
                            "
                  >

                    <th className="p-3 text-left">
                      Date
                    </th>

                    <th className="p-3 text-left">
                      Wallet
                    </th>

                    <th className="p-3 text-right">
                      Amount
                    </th>

                    <th className="p-3 text-left">
                      Note
                    </th>

                    <th className="p-3 text-left">
                      Received By
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {

                    payments.map(

                      (payment) => (

                        <tr
                          key={payment.id}
                          className="
                                        border-b
                                        border-yellow-500/10
                                        "
                        >

                          <td className="p-3">

                            {

                              new Date(

                                payment.payment_date

                              ).toLocaleString()

                            }

                          </td>

                          <td className="p-3">

                            {

                              payment.wallet_name

                            }

                          </td>

                          <td
                            className="
                                            p-3
                                            text-right
                                            text-green-400
                                            font-bold
                                            "
                          >

                            ₹

                            {

                              Number(

                                payment.paid_amount

                              ).toFixed(2)

                            }

                          </td>

                          <td className="p-3">

                            {

                              payment.note ||

                              "-"

                            }

                          </td>

                          <td className="p-3">

                            {

                              payment.received_by ||

                              "-"

                            }

                          </td>

                        </tr>

                      )

                    )

                  }

                </tbody>

              </table>

            </div>

          )

        }

      </div>

    </div>

  </div>

  );
}

export default ViewPurchase;
